import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface SetupStatus {
  departamentos: boolean;
  cargos: boolean;
  times: boolean;
  pessoas: boolean;
  agentes: boolean;
  dispensado: boolean;
  completo: boolean;
}

export interface SetupItem {
  key: keyof Omit<SetupStatus, 'dispensado' | 'completo'>;
  label: string;
  descricao: string;
  link: string;
  queryParams: Record<string, string>;
  icon: string;
  concluido: boolean;
}

@Component({
  selector: 'app-setup-checklist',
  templateUrl: './setup-checklist.component.html',
  styleUrls: ['./setup-checklist.component.scss']
})
export class SetupChecklistComponent {

  expanded = false;

  @Input() set status(value: SetupStatus | null) {
    if (value) {
      this._status = value;
      this.buildItems();
    }
  }

  @Output() dispensar = new EventEmitter<void>();

  _status: SetupStatus | null = null;
  items: SetupItem[] = [];

  get concluidos(): number {
    return this.items.filter(i => i.concluido).length;
  }

  get total(): number {
    return this.items.length;
  }

  get progressPercent(): number {
    return this.total > 0 ? (this.concluidos / this.total) * 100 : 0;
  }

  toggleExpanded(): void {
    this.expanded = !this.expanded;
  }

  onDispensar(): void {
    this.dispensar.emit();
  }

  private buildItems(): void {
    if (!this._status) return;
    this.items = [
      {
        key: 'departamentos',
        label: 'Criar departamentos',
        descricao: 'Monte a estrutura com pelo menos 1 departamento além do "Geral"',
        link: '/organizacao',
        queryParams: { tab: 'departamentos' },
        icon: 'pi pi-building',
        concluido: this._status.departamentos
      },
      {
        key: 'cargos',
        label: 'Criar cargos',
        descricao: 'Cadastre os cargos que existem na sua empresa',
        link: '/organizacao',
        queryParams: { tab: 'cargos' },
        icon: 'pi pi-id-card',
        concluido: this._status.cargos
      },
      {
        key: 'times',
        label: 'Criar times',
        descricao: 'Crie pelo menos 1 time e vincule a um departamento',
        link: '/organizacao',
        queryParams: { tab: 'times' },
        icon: 'pi pi-users',
        concluido: this._status.times
      },
      {
        key: 'pessoas',
        label: 'Adicionar pessoas',
        descricao: 'Cadastre gestores e colaboradores na hierarquia',
        link: '/organizacao',
        queryParams: { tab: 'hierarquia' },
        icon: 'pi pi-user-plus',
        concluido: this._status.pessoas
      },
      {
        key: 'agentes',
        label: 'Instalar o Agent',
        descricao: 'Instale o agente em pelo menos 1 máquina',
        link: '/organizacao',
        queryParams: { tab: 'hierarquia' },
        icon: 'pi pi-desktop',
        concluido: this._status.agentes
      }
    ];
  }
}
